import { Helmet } from 'react-helmet';
import ColabsTable from './ColabsTable';

function Colab() {
  return (
    <div>
      <Helmet>
        <title>Co:Lab Data</title>
      </Helmet>
      <div>
        <ColabsTable />
      </div>
    </div>
  );
}

export default Colab;
